/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { RenderSections } from '@components/UI/Common/SectionCommonUI';

/* Services */

/**
 * Renders the Health Common UI component.
 * @param {Array} pageBody - Content from api.
 * @param {string} region - Current User Country.
 * @param {string} lang - Current User Language.
 * @returns {ReactElement} Health Common UI Component.
 */
const HealthCommonUI = ({ pageBody, region, lang }) => {
  return (
    <Box as="section" className="container-article btn-center">
      {pageBody && pageBody.length
        ? pageBody.map((section, i) => {
          return (
            <RenderSections
              section={section}
              region={region}
              lang={lang}
              pType="health"
              key={i}
            />
          );
          })
        : null}
    </Box>
  );
};

export default HealthCommonUI;
